/**
 * PlayerLive page.
 */
import PlayerTemplate from '@components/templates/player';
import useLive from '@components/pages/player/useLive';

/**
 * Main page component for displaying the live player template.
 * Fetches and displays the zapper template with the current channel.
 */
export default function PlayerLivePage() {
  const props = useLive();
  return <PlayerTemplate {...props} />;
}
